export const ToggleDisableSid = 'MSS_HideSid';
export const ToggleDisableDispensation = 'APS_HideDispensation';
